import {$clientApi} from "../http";
import {
    IAppointmentPriceResponse,
    IClassEventForAppointment, IRequestModelForAppointmentPrice,
    IRequestModelForAppointmentTime, IRequestModelForBuyingAppointmentByCash,
    ITimeForAppointment
} from "../models/ClassEventReservation";
import {IInstructorClasses} from "../models/Trainer";

class AppointmentServiceClass {

    async getClassesForAppointments() {
        return $clientApi.get<IClassEventForAppointment[]>(`api/trainning-courses/appointment-enabled-courses`);
    }

    async getInstructorsForAppointment() {
        return $clientApi.get<IInstructorClasses[]>(`api/instructors/instructor-classes`);
    }

    async getAvailableTime(model: IRequestModelForAppointmentTime) {
        return $clientApi.post<ITimeForAppointment[]>(`api/instructors/day-availability`, model);
    }

    async getAppointmentPrice(model: IRequestModelForAppointmentPrice) {
        let queryString = `instructorId=${model.instructorId}&trainingCourseId=${model.trainingCourseId}`;
        if (model.couponCode) {
            queryString += `&couponCode=${model.couponCode}`;
        }
        if (model.loyaltyExchangeId) {
            queryString += `&loyaltyExchangeId=${model.loyaltyExchangeId}`;
        }
        return $clientApi.get<IAppointmentPriceResponse>(`api/appointments/get-price?${queryString}`);
    }

    async buyAppointmentByCash(model: IRequestModelForBuyingAppointmentByCash) {
        return $clientApi.post<{appointmentId: number, success?: boolean, error?: {message: string}}>(`/api/appointments/pay-with-cash`, model);
    }

}

export const AppointmentService = new AppointmentServiceClass()